import React from "react";
import ItemControlPanel from "../../elements/AnItemControlPanel";
import AnItemLinked from "../../elements/AnItemLinked";
import { UserCircle, UserCirclePlus } from "@phosphor-icons/react";
import { ClinicDetailsFields } from "./ClinicDetailsFields";

export const ClinicForm = (
  classes,
  data,
  errors,
  onChange,
  onDeleteItem,
  theme,
  isDeletingItem,
  providers,
  onSearch,
  onProviderSelect,
  onSubmitProvider,
  isCreatingItem,
  onCloseAction
) => {
  const mapItems = data?.physician_clinic?.map((obj) => ({
    id: obj.id,
    clinic_id: obj.physician_id,
    text: obj.physician.first_name + " " + obj.physician.last_name,
  }));
  const mapProviders = providers
    ?.filter((provider) => !mapItems?.some((item) => item.clinic_id === provider.id))
    .map((provider) => ({
      id: provider.id,
      name: provider.first_name + " " + provider.last_name,
    }));
  return [
    ...ClinicDetailsFields({ data, errors, onChange }),
    {
      id: "providers",
      label: "Providers",
      headerTitle: "Providers",
      headerDescription: "Connect providers to the clinic from the provider library",
      input: (
        <>
          <ItemControlPanel
            classes={classes}
            items={mapItems}
            renderItem={(item) => (
              <AnItemLinked
                text={item?.text || ""}
                buttonIcon={<UserCirclePlus fontSize={"20px"} weight="duotone" />}
                editMode={true}
                onDeleteItem={() => onDeleteItem(item.id)}
                isDeletingItem={isDeletingItem}
              />
            )}
            buttonIcon={
              <UserCirclePlus
                fontSize={"20px"}
                weight="duotone"
                color={theme.palette.primary.main}
              />
            }
            listItemIcon={<UserCircle fontSize={"20px"} weight="duotone" />}
            buttonText="Connect Providers"
            stepsDialog={[<></>]}
            defaultValuesDialog={" Connect Providers"}
            submitLabelDialog={" Connect Providers"}
            titleDialog={"Connect Providers"}
            titleSubmitDialog={"Connect Provider"}
            descriptionDialog={"Choose providers below to connect with the Clinic’s profile."}
            onSubmitDialog={onSubmitProvider}
            onCheckboxSelected={onProviderSelect}
            filteredItems={mapProviders}
            onSearch={onSearch}
            isSubmittingDialog={isCreatingItem}
            searchInputPlaceHolder={"Search Providers"}
            onCloseAction={onCloseAction}
          />
        </>
      ),
      paddingTop: 0,
      cols: 12,
      divider: true,
    },
  ];
};
